module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("PART I")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Carmarthen, Wales")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("July 1777")]), _vm._v(" "), _c('p', {
    staticClass: "center1b"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Six years earlier")])]), _vm._v(" "), _c('p', {
    staticClass: "epip"
  }, [_vm._v("If you marry a green youth,")]), _vm._v(" "), _c('p', {
    staticClass: "epip"
  }, [_vm._v("you will cut the sprouting corn;")]), _vm._v(" "), _c('p', {
    staticClass: "epip"
  }, [_vm._v("and you may find that the harvest")]), _vm._v(" "), _c('p', {
    staticClass: "epip"
  }, [_vm._v("is too stormy to be borne.")])]), _c('p', {
    staticClass: "epipc"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("—ANONYMOUS, “STANZAS FOR THE HARP”")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5121f7b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 78
// module chunks = 0